import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { toChoiceQuestionAnswerOrEmpty } from '../../stores/QuestionStore';
import { DisplayMode } from '../RenderForm';
import { EditMultiChoice } from './edit/EditMultiChoice';
import { ViewMultiChoice } from './view/ViewMultiChoice';
export var MultiChoice = observer(function (_ref) {
  var id = _ref.id,
    errorId = _ref.errorId,
    descriptionId = _ref.descriptionId,
    questionStore = _ref.questionStore,
    displayMode = _ref.displayMode;
  var availableOptions = questionStore.availableOptions();
  var currentAnswer = toChoiceQuestionAnswerOrEmpty(questionStore.currentAnswer);
  var currentOptions = availableOptions.filter(function (option) {
    return currentAnswer.choices.includes(option.value);
  });
  var hasOtherChoice = !!questionStore.otherChoiceId;
  var showEditComponent = displayMode === DisplayMode.Edit;
  if (showEditComponent) {
    var _questionStore$formQu;
    var onChange = function onChange(event) {
      var newChoiceId = event.target.value;
      var currentAnswer = toChoiceQuestionAnswerOrEmpty(questionStore.currentAnswer);
      var newChoiceIds = _toConsumableArray(toJS(currentAnswer.choices));
      if (newChoiceIds.includes(newChoiceId)) {
        newChoiceIds = newChoiceIds.filter(function (choiceId) {
          return choiceId !== newChoiceId;
        });
      } else {
        newChoiceIds.push(newChoiceId);
      }
      questionStore.setAnswer({
        text: hasOtherChoice && newChoiceIds.some(function (choiceId) {
          return choiceId === questionStore.otherChoiceId;
        }) ? currentAnswer.text : '',
        choices: newChoiceIds
      });
    };
    var otherChoiceSelected = hasOtherChoice && currentOptions.some(function (option) {
      return option.value === questionStore.otherChoiceId;
    });
    var onOtherChoiceTextChange = function onOtherChoiceTextChange(event) {
      questionStore.setAnswer({
        text: event.target.value,
        choices: toChoiceQuestionAnswerOrEmpty(questionStore.currentAnswer).choices
      });
    };
    return /*#__PURE__*/React.createElement(EditMultiChoice, {
      id: id,
      errorId: errorId,
      descriptionId: descriptionId,
      options: availableOptions,
      value: currentOptions,
      isInvalid: !!questionStore.validationErrors,
      isRequired: (_questionStore$formQu = questionStore.formQuestion) === null || _questionStore$formQu === void 0 || (_questionStore$formQu = _questionStore$formQu.validation) === null || _questionStore$formQu === void 0 ? void 0 : _questionStore$formQu.rq,
      onChange: onChange,
      hasOtherOption: hasOtherChoice,
      otherOptionSelected: otherChoiceSelected,
      otherOptionText: currentAnswer.text,
      onOtherOptionTextChange: onOtherChoiceTextChange
    });
  }
  return /*#__PURE__*/React.createElement(ViewMultiChoice, {
    id: id,
    options: availableOptions,
    value: currentOptions,
    hasOtherOption: hasOtherChoice,
    otherOptionText: currentAnswer.text,
    displayMode: displayMode
  });
});